import angular from 'angular';
import ResendGiftNotificationModalComponent from './resend.gift.notification.modal.component';
export default angular.module('inv.customer.orderHistory.orderDetails.resendGiftNotificationModal', []).component('resendGiftNotificationModal', ResendGiftNotificationModalComponent).name;